module.exports = __webpack_public_path__ + "static/media/1@2x.30317a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_150/img/1@2x.png
// module id = 1473
// module chunks = 0